import styled from 'styled-components';

export const SummaryQuote = styled.div`
    padding-bottom: 2rem;
    color: var(--black);
`;

export const TotalPriceText = styled.div`
    font-weight: 700;
    & .tcc {
        vertical-align: top;
        line-height: 29px;
        font-size: 12px;
        font-weight: 700;
    }
`;

export const PriceItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    order: ${({ order }) => order}
`;

export const PriceItems = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TRoomPrice = styled.div`
    line-height: 36px;
    font-family: 'helvetica-neue-bold';
    font-weight: bold;
    padding-right: 1rem 10px;
`;
